import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";
import * as _ from "lodash";

export class SchedulingProjectAlertsService {

  constructor(private bringozToastService: BringozToastService) {
  }

  // CREATE //
  createVisitPlanSuccess() {
    const message = {
      body: 'VISIT_PLAN_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createVisitPlanError() {
    const message = {
      body: 'VISIT_PLAN_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateVisitPlanSuccess() {
    const message = {
      body: 'VISIT_PLAN_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  // SYNCHING
  syncVisitPlan() {
    const message = {
      body: 'VISIT_PLAN_SYNC_IN_PROGRESS'
    };
    return this.bringozToastService.info(message)
  }

  // VISIT_PLAN_SYNC_IS_NEEDED_BEFORE_ACTION
  syncVisitPlanNeededBeforeActionInfo() {
    const message = {
      body: 'VISIT_PLAN_SYNC_IS_NEEDED_BEFORE_ACTION'
    };
    return this.bringozToastService.info(message)
  }

  // A deleted (archived) project is read only - inform the user instead of silently doing nothing
  deletedProjectActionBlocked() {
    const message = {
      body: 'VISIT_PLAN_DELETED_ACTION_BLOCKED'
    };
    return this.bringozToastService.info(message)
  }

  // VISIT_PLAN_REOPTIMIZE_ROUTES_WHEN_DISPATCHED_ERROR
  reoptimizeRoutesWhenDispatchedError() {
    const message = {
      body: 'VISIT_PLAN_REOPTIMIZE_ROUTES_WHEN_DISPATCHED_ERROR'
    };
    return this.bringozToastService.info(message)
  }

  // VISIT_PLAN_REOPTIMIZE_ROUTES_WHEN_DISPATCHED_ERROR
  resourceIsPublishedInAnotherPlan() {
    const message = {
      body: 'VISIT_PLAN_RESOURCE_IS_PUBLISHED_IN_ANOTHER_PLAN_ERROR'
    };
    return this.bringozToastService.info(message)
  }

  updateVisitPlanError() {
    const message = {
      body: 'VISIT_PLAN_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteSuccess() {
    const message = {
      body: 'VISIT_PLAN_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteError() {
    const message = {
      body: 'VISIT_PLAN_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  restoreSuccess() {
    const message = {
      body: 'VISIT_PLAN_RESTORE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  restoreError() {
    const message = {
      body: 'VISIT_PLAN_RESTORE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // LOCK ROUTE //
  lockRouteSuccess() {
    const message = {
      body: 'ROUTE_LOCK_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  lockRouteError() {
    const message = {
      body: 'ROUTE_LOCK_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UNLOCK ROUTE //
  unlockRouteSuccess() {
    const message = {
      body: 'ROUTE_UNLOCK_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  unlockRouteError() {
    const message = {
      body: 'ROUTE_UNLOCK_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // LOCK ACCOUNT //
  lockAccountSuccess() {
    const message = {
      body: 'ACCOUNT_LOCK_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  lockAccountError() {
    const message = {
      body: 'ACCOUNT_LOCK_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // REMOVE_DELIVERIES //
  removeDeliveriesSuccess() {
    const message = {
      body: 'VISIT_PLAN_REMOVE_DELIVERIES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  removeDeliveriesError() {
    const message = {
      body: 'VISIT_PLAN_REMOVE_DELIVERIES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UNLOCK ACCOUNT //
  unlockAccountSuccess() {
    const message = {
      body: 'ACCOUNT_UNLOCK_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  unlockAccountError() {
    const message = {
      body: 'ACCOUNT_UNLOCK_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // LOCK DAY //
  lockDaySuccess() {
    const message = {
      body: 'DAY_LOCK_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  lockDayError() {
    const message = {
      body: 'DAY_LOCK_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UNLOCK DAY //
  unlockDaySuccess() {
    const message = {
      body: 'DAY_UNLOCK_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  unlockDayError() {
    const message = {
      body: 'DAY_UNLOCK_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // LOCK JOB //
  lockJobSuccess() {
    const message = {
      body: 'JOB_LOCK_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  lockJobError() {
    const message = {
      body: 'JOB_LOCK_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UNLOCK JOB //
  unlockJobSuccess() {
    const message = {
      body: 'JOB_UNLOCK_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  unlockJobError() {
    const message = {
      body: 'JOB_UNLOCK_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // LOCK CALL //
  lockCallSuccess() {
    const message = {
      body: 'CALL_LOCK_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  lockCallError() {
    const message = {
      body: 'CALL_LOCK_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UNLOCK CALL //
  unlockCallSuccess() {
    const message = {
      body: 'CALL_UNLOCK_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  unlockCallError() {
    const message = {
      body: 'CALL_UNLOCK_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // MANUAL_REFRESH //
  manualRefreshScheduleSuccess() {
    const message = {
      body: 'SCHEDULING_PROJECT_MANUAL_REFRESH_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  manualRefreshScheduleError() {
    const message = {
      body: 'SCHEDULING_PROJECT_MANUAL_REFRESH_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE_DELIVERY_DATA //
  updateDeliveryDataSuccess() {
    const message = {
      body: 'SCHEDULING_PROJECT_UPDATE_DELIVERY_DATA_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateDeliveryDataError() {
    const message = {
      body: 'SCHEDULING_PROJECT_UPDATE_DELIVERY_DATA_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DISCARD_CELL_TRACKERS //
  discardCellTrackersSuccess() {
    const message = {
      body: 'SCHEDULING_PROJECT_DISCARD_CELL_TRACKERS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  discardCellTrackersError() {
    const message = {
      body: 'SCHEDULING_PROJECT_DISCARD_CELL_TRACKERS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // SUBMIT_CELL_TRACKERS //
  submitCellTrackersSuccess() {
    const message = {
      body: 'SCHEDULING_PROJECT_SUBMIT_CELL_TRACKERS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  submitCellTrackersError() {
    const message = {
      body: 'SCHEDULING_PROJECT_SUBMIT_CELL_TRACKERS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // RESOURCE_OCCUPIED_PUBLISHED //
  resourceOccupiedPublishedInfo(name) {
    const message = {
      body: 'SCHEDULING_PROJECT_RESOURCE_OCCUPIED_PUBLISHED_INFO'
    };
    return this.bringozToastService.info(message, {name: name})
  }

  // PUBLISH_VISIT_SCHEDULE //
  publishVisitScheduleSuccess() {
    const message = {
      body: 'SCHEDULING_PROJECT_PUBLISH_VISIT_SCHEDULE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  publishVisitScheduleError() {
    const message = {
      body: 'SCHEDULING_PROJECT_PUBLISH_VISIT_SCHEDULE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateAutoDispatchSettingsError() {
    const message = {
      body: 'SCHEDULING_PROJECT_UPDATE_AUTO_DISPATCH_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateAutoDispatchSettingsSuccess() {
    const message = {
      body: 'SCHEDULING_PROJECT_UPDATE_AUTO_DISPATCH_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  // CREATE_ROUTE //
  createRouteSuccess() {
    const message = {
      body: 'SCHEDULING_PROJECT_CREATE_ROUTE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createRouteError() {
    const message = {
      body: 'SCHEDULING_PROJECT_CREATE_ROUTE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE_CALLS //
  deleteCallsSuccess() {
    const message = {
      body: 'SCHEDULING_PROJECT_DELETE_CALLS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteCallsError() {
    const message = {
      body: 'SCHEDULING_PROJECT_DELETE_CALLS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // MOVE_DAY_CALLS //
  moveDayCallsSuccess() {
    const message = {
      body: 'SCHEDULING_PROJECT_MOVE_DAY_CALLS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  moveDayCallsError() {
    const message = {
      body: 'SCHEDULING_PROJECT_MOVE_DAY_CALLS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE_ROUTES //
  deleteRoutesSuccess() {
    const message = {
      body: 'SCHEDULING_PROJECT_DELETE_ROUTES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  // REFRESH_VISIT_PLAN // Refresh Visit Plan
  syncVisitPlanSuccess() {
    const message = {
      body: 'SCHEDULING_PROJECT_REFRESH_VISIT_PLAN_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteRoutesError() {
    const message = {
      body: 'SCHEDULING_PROJECT_DELETE_ROUTES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  // REASSIGN //
  reassignError() {
    const message = {
      body: 'VISIT_SCHEDULE_REASSIGN_ERROR',
      details: 'VISIT_SCHEDULE_DAY_COMPLETED_CANNOT_CREATE_ROUTE'
    };
    return this.bringozToastService.error(message)
  }

  reassignRouteError() {
    const message = {
      body: 'REASSIGN_ROUTE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // EDIT_RESOURCES //
  editResourcesSkillRequiredError() {
    const message = {
      body: 'VISIT_SCHEDULE_EDIT_RESOURCES_SKILL_REQUIRED_ERROR'
    };
    return this.bringozToastService.error(message)
  }

  createRouteDayDispatchedError() {
    return this._dayDispatchedError('SCHEDULING_PROJECT_DAY_DISPATCHED_CANNOT_CREATE_ROUTE');
  }

  moveJobsDayDispatchedError() {
    return this._dayDispatchedError('VISIT_SCHEDULE_DAY_DISPATCHED_CANNOT_MOVE_JOBS');
  }

  moveToLeftoversDayDispatchedError() {
    return this._dayDispatchedError('VISIT_SCHEDULE_DAY_DISPATCHED_CANNOT_MOVE_TO_LEFTOVERS');
  }

  reassignRouteDayDispatchedError() {
    return this._dayDispatchedError('VISIT_SCHEDULE_REASSIGN_ROUTE_DAY_DISPATCHED_ERROR');
  }

  reassignCallDayDispatchedError() {
    return this._dayDispatchedError('VISIT_SCHEDULE_REASSIGN_CALL_DAY_DISPATCHED_ERROR');
  }

  private _dayDispatchedError(body: string) {
    const message = {
      body,
      details: 'VISIT_SCHEDULE_DAY_DISPATCHED_DETAILS'
    };
    return this.bringozToastService.error(message)
  }

  // REFRESH_ROUTES //
  refreshRoutesSuccess() {
    const message = {
      body: 'SCHEDULING_PROJECT_REFRESH_ROUTES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  // CREATE_TEMPLATE //
  createTemplateSuccess() {
    const message = {
      body: 'TEMPLATE_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createTemplateError() {
    const message = {
      body: 'TEMPLATE_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE_TEMPLATE //
  updateTemplateSuccess() {
    const message = {
      body: 'TEMPLATE_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateTemplateError() {
    const message = {
      body: 'TEMPLATE_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE_TEMPLATE //
  deleteTemplateSuccess() {
    const message = {
      body: 'TEMPLATE_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteTemplateError() {
    const message = {
      body: 'TEMPLATE_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // IMPORT_AGENTS //
  importAgentsSuccess() {
    const message = {
      body: 'SCHEDULING_PROJECT_IMPORT_AGENTS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  importAgentsError() {
    const message = {
      body: 'SCHEDULING_PROJECT_IMPORT_AGENTS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // Import visit configurations failed
  importVisitConfigurationsFailed(error?) {
    const message = {
      body: "VISIT_CONFIGURATION_IMPORT_FAILED",
      details: "SOMETHING_WENT_WRONG",
      message: _.get(error, 'more_info')
    }
    return this.bringozToastService.error(message);
  }

  // Validation visit configuration failed
  validationVisitConfigurationsFailed() {
    const message = {
      body: 'VISIT_CONFIGURATION_UPLOAD_FAILED_BODY',
      details: "VISIT_CONFIGURATION_IMPORT_FAILED"
    }
    return this.bringozToastService.error(message);
  }
  // Upload visit configurations succeeded
  uploadVisitConfigurationsSuccess() {
    const message = {
      body: 'VISIT_CONFIGURATION_UPLOAD_SUCCESS'
    }
    return this.bringozToastService.success(message);
  }

  bulkExpireVisitConfigurationsSuccess() {
    const message = {
      body: 'VISIT_CONFIGURATION_BULK_EXPIRE_SUCCESS'
    }
    return this.bringozToastService.success(message);
  }

  bulkExpireVisitConfigurationsError(error) {
    let body;
    switch (error && error.code) {
      case 400470: body = 'VISIT_CONFIGURATION_BULK_EXPIRE_NOT_FOUND'; break;
      case 400471: body = 'VISIT_CONFIGURATION_BULK_EXPIRE_BRANCHES_NOT_FOUND'; break;
      default: body = 'VISIT_CONFIGURATION_BULK_EXPIRE_ERROR'; break;
    }

    const message = {
      body: body,
      details: 'SOMETHING_WENT_WRONG'
    }
    return this.bringozToastService.error(message);
  }

  bulkExpireVisitConfigurationsNoFiltersInfo() {
    const message = {
      body: 'VISIT_CONFIGURATION_BULK_EXPIRE_NO_FILTERS_INFO'
    };
    return this.bringozToastService.info(message)
  }

  bulkExpireVisitConfigurationsEmptyListInfo() {
    const message = {
      body: 'VISIT_CONFIGURATION_BULK_EXPIRE_NOT_FOUND'
    };
    return this.bringozToastService.info(message)
  }

  visitSchedulePublishAbortSuccess() {
    const message = {
      body: 'VISIT_SCHEDULE_PUBLISH_ABORT_SUCCESS'
    }
    return this.bringozToastService.success(message);
  }

  visitScheduleOptimizationAbortSuccess() {
    const message = {
      body: 'VISIT_SCHEDULE_OPTIMIZATION_ABORT_SUCCESS'
    }
    return this.bringozToastService.success(message);
  }

  visitScheduleRecalcSuccess() {
    const message = {
      body: 'VISIT_SCHEDULE_RECALC_SUCCESS'
    }
    return this.bringozToastService.success(message);
  }

  syncVisitPlanAccountsSuccess() {
    const message = {
      body: 'SCHEDULING_PROJECT_SYNC_VISIT_PLAN_ACCOUNTS_SUCCESS'
    };
    return this.bringozToastService.success(message);
  }

  syncVisitPlanAccountsError() {
    const message = {
      body: 'SCHEDULING_PROJECT_SYNC_VISIT_PLAN_ACCOUNTS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message);
  }

  onError(error) {
    const message = {
      message: _.get(error, 'more_info'),
    };
    return this.bringozToastService.error(message)
  }

  noMatchingSkillsInfo() {
    const message = {
      body: 'RESOURCES_NO_MATCHING_SKILLS_INFO'
    };
    return this.bringozToastService.info(message)
  }

  moveBetweenDaysInfo() {
    const message = {
      body: 'VISIT_SCHEDULE_MOVE_BETWEEN_DAYS_INFO'
    };
    return this.bringozToastService.info(message)
  }

}

angular
  .module('bringoz.admin.scheduling-project')
  .service('schedulingProjectAlertsService', SchedulingProjectAlertsService);
